// store/index.ts
import {configureStore} from '@reduxjs/toolkit';
import chatReducer from './chatSlice';
import videoChatReducer from './videoChatSlice';

const store = configureStore({
  reducer: {
    chat: chatReducer,
    videoChat: videoChatReducer
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
